module.exports = __webpack_public_path__ + "static/media/consumers-choice.3de918fe.png";